import Vue from 'vue'
import Vuex from 'vuex'
import access from './modules/access'
import apiKeys from './modules/apiKeys'
import improvementIdea from './modules/improvementIdea'
import problemSolving from './modules/problemSolving'
import quickAction from './modules/quickAction'
import challenge from './modules/challenge'
import people from './modules/people'
import organization from './modules/organization'
import site from './modules/site'
import notifications from './modules/notifications'
import audit from './modules/audit'
import improvementIdeaPrint from './modules/improvementIdeaPrint'
import problemSolvingPrint from './modules/problemSolvingPrint'
import quickActionPrint from './modules/quickActionPrint'
import validations from './modules/validations'
import modals from './modules/modals'
import globalGetters from './globalGetters'
import globalActions from './globalActions'
import globalMutations from './globalMutations'
import globalState from './globalState'
import { createHomeSnapshotsPersistence, createReverPersistence } from './persistence'
import report from './modules/report'
import shareModal from './modules/shareModal'
import attachments from './modules/attachments'
import comments from './modules/comments'
import siteSettings from './modules/siteSettings'
import signup from './modules/signup'
import categories from './modules/categories'
import situationTypes from './modules/situationTypes'
import organizationSettings from './modules/organizationSettings'
import sitesTable from './modules/sitesTable'
import webhooks from './modules/webhooks'
import profileSettings from './modules/profileSettings'
import profile from './modules/profile'
import teams from './modules/teams'
import homeSnapshots from './modules/homeSnapshots'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    access,
    apiKeys,
    improvementIdea,
    problemSolving,
    quickAction,
    challenge,
    organization,
    people,
    site,
    signup,
    report,
    notifications,
    audit,
    improvementIdeaPrint,
    problemSolvingPrint,
    quickActionPrint,
    validations,
    modals,
    shareModal,
    attachments,
    comments,
    siteSettings,
    categories,
    situationTypes,
    organizationSettings,
    sitesTable,
    webhooks,
    profileSettings,
    profile,
    teams,
    homeSnapshots,
  },
  strict: debug,
  debug: true,
  plugins: [createReverPersistence(), createHomeSnapshotsPersistence()],
  actions: globalActions,
  getters: globalGetters,
  mutations: globalMutations,
  state: globalState,
})
